import React from 'react';

import SvgIcon from '@mui/material/SvgIcon';
import { Checkbox, CheckboxProps } from '@mui/material';

import { ReactComponent as CheckIcon } from 'assets/icons/check-balance.svg';
import { ReactComponent as UnCheckIcon } from 'assets/icons/empty-circle.svg';

const TableCheckbox = (props: CheckboxProps) => {
  const Icon = (
    <SvgIcon>
      <UnCheckIcon />
    </SvgIcon>
  );

  const Checked = (
    <SvgIcon>
      <CheckIcon />
    </SvgIcon>
  );
  return <Checkbox icon={Icon} checkedIcon={Checked} {...props} />;
};

export default TableCheckbox;
